import script from "./AgentView.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentView.vue?vue&type=script&setup=true&lang=js"

import "./AgentView.vue?vue&type=style&index=0&id=0430fa9c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0430fa9c"]])

export default __exports__